import { BookmarkCheck, PencilLine, Loader2 } from "lucide-react";

/**
 * Ações do rascunho, ancoradas na bolha em que ele nasceu.
 *
 * UAT 2026-08-13: a IA anunciava "registrei no painel" e o rascunho ficava lá
 * parado — a Biblioteca só lista o que está salvo, e a usuária não tinha como
 * saber que faltava confirmar. Salvar acontece por rota direta (não pelo modelo),
 * então o clique não depende de o agente interpretar uma frase.
 */
export default function ArtifactActions({ onSave, onKeepDraft, saving = false, done = null }) {
  if (done === "saved") {
    return (
      <p
        data-testid="artifact-actions-done"
        className="mt-2 flex items-center gap-1.5 text-[12.5px] text-brand-sage"
      >
        <BookmarkCheck className="w-3.5 h-3.5" /> Salvo na Biblioteca
      </p>
    );
  }
  if (done === "draft") {
    return (
      <p
        data-testid="artifact-actions-done"
        className="mt-2 flex items-center gap-1.5 text-[12.5px] text-brand-ink2"
      >
        <PencilLine className="w-3.5 h-3.5" /> Guardado como rascunho
      </p>
    );
  }

  return (
    <div data-testid="artifact-actions" className="mt-2.5 flex flex-wrap items-center gap-2">
      <button
        type="button"
        data-testid="artifact-action-save"
        onClick={onSave}
        disabled={saving}
        className="inline-flex items-center gap-1.5 min-h-[40px] px-3.5 rounded-full bg-brand-rose hover:bg-brand-roseHover text-white text-[13px] font-ui transition-colors disabled:opacity-60"
      >
        {saving ? (
          <Loader2 className="w-3.5 h-3.5 animate-spin" />
        ) : (
          <BookmarkCheck className="w-3.5 h-3.5" />
        )}
        Gostei, salva
      </button>
      <button
        type="button"
        data-testid="artifact-action-draft"
        onClick={onKeepDraft}
        disabled={saving}
        className="inline-flex items-center gap-1.5 min-h-[40px] px-3.5 rounded-full bg-brand-elevated border border-brand-line text-brand-ink2 hover:border-brand-rose hover:text-brand-ink text-[13px] font-ui transition-colors disabled:opacity-60"
      >
        <PencilLine className="w-3.5 h-3.5" />
        Deixar como rascunho
      </button>
    </div>
  );
}
